import { Breadcrumb, HeaderToolbar, Tooltip } from "@xola/ui-kit";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Affiliate } from "types";
import { EditAgent } from "../../../components/Agent/EditAgent";
import { ColumnLayout } from "../../../components/Layout/ColumnLayout";
import { useSeller } from "../../../hooks/useAccount";
import { useInvalidate } from "../../../hooks/useInvalidation";
import { useResource } from "../../../hooks/useResource";
import { Page } from "../../Page";
import { NoTranslate } from "@/components/Common/NoTranslate";
import { EmbeddedAppTriggerLocation } from "@/embeddedApps/EmbeddedAppTriggerLocation";

export const EditAgentPage = () => {
    const { id } = useParams<{ id?: string }>();
    const seller = useSeller();
    const invalidate = useInvalidate();
    const { data: agent } = useResource<Affiliate>(["affiliates", id]);
    const history = useHistory();

    const handleClickAgents = () => {
        history.push("/distribution/agents");
    };

    const handleSaveAgent = (agentId?: ID) => {
        invalidate("affiliates", agentId);
        invalidate("partners", agentId);

        /**
         * Invalidating Seller because seller contains delegate Data.
         * when allow access is enabled, seller does not have delegate, but
         * we want to access the seller data in next tabs. so invalidating the seller also
         **/
        invalidate("sellers", seller.id);

        if (!agentId) {
            handleClickAgents();
        }
    };

    return (
        <Page title="Agents">
            <ColumnLayout>
                <ColumnLayout.Fill>
                    <HeaderToolbar>
                        <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                            <Breadcrumb.Item>Distribution</Breadcrumb.Item>
                            <Breadcrumb.Item onClick={handleClickAgents}>Agents</Breadcrumb.Item>
                            <NoTranslate>
                                <Tooltip content={agent?.name ?? "New Agent"}>
                                    <Breadcrumb.Item>{agent?.name ?? "New Agent"}</Breadcrumb.Item>
                                </Tooltip>
                            </NoTranslate>
                        </HeaderToolbar.Breadcrumb>
                        {id && (
                            <EmbeddedAppTriggerLocation
                                id="distribution.agents.detail.headerBar"
                                context={{ agents: [{ id }] }}
                            />
                        )}
                    </HeaderToolbar>
                    <EditAgent agent={agent} onSave={handleSaveAgent} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
